import React, { useState, useEffect } from "react";

import favoriteProductsAPI from "../../API/favoriteProducts.api";
import { ErrorAlert } from "../../utils/Alerts";
import LogCapture from "../../utils/LogManagement/LogHelper";

const ProductHeaderCard = ({ model, productId, isPreview }) => {
    const [isFav, setIsFav] = useState(false);

    useEffect(() => {
        setIsFav(model?.favorite);
    }, [model?.favorite]);

    const renderMaterialNames = () => {
        return [...new Set(model?.materialNames)]?.join(", ");
    };

    const toggleFavoriteProduct = async () => {
        try {
            setIsFav(!isFav);
            favoriteProductsAPI
                .toggleFavoriteProduct(productId)
                .then(
                    LogCapture.info(
                        `product with id ${productId} is set to favorite`
                    )
                );
        } catch (error) {
            ErrorAlert(error.message || error);
            LogCapture.error(
                `product with id ${productId} can not be set to favorite`
            );
        }
    };

    return (
        <>
            <div className="flex justify-between">
                <div className="market-header">
                    <h3 className="medium-title-bold capitalize">
                        {model?.productName}
                    </h3>
                    <span className="market-item-type success">
                        {renderMaterialNames()}
                    </span>
                </div>
                {/* <div>
                    <h3 className="medium-title-bold">{materialName}</h3>
                    <div>wf</div> */}
                {/* <div className="rate-items">
                    <div className="rating-section flex items-center">
                        <StarsRating starsRating={starsRating} />
                    </div>
                </div> */}
                {/* </div> */}
                {!isPreview && (
                    <div className="favorites-btn with-popover">
                        {/* <Tippy
                        content="ADD TO FAVORITES"
                        placement="top"
                        animation="scale"
                    > */}
                        <span
                            onClick={toggleFavoriteProduct}
                            tabIndex="0"
                            className="tooltip-container"
                        >
                            <i
                                className={`fas fa-star popover-shower ${
                                    isFav ? "rated" : ""
                                }`}
                            ></i>
                        </span>
                        {/* </Tippy> */}
                    </div>
                )}
            </div>
        </>
    );
};

export default ProductHeaderCard;
